<template>
    <div class="filter-entry">
        <div class="filter-label">
            {{ name }}
        </div>
        <el-date-picker class="filter-number" v-model="data[id + '_from']" value-format="yyyy-MM-dd"></el-date-picker> - <el-date-picker class="filter-number" v-model="data[id + '_to']" value-format="yyyy-MM-dd"></el-date-picker>
    </div>
</template>

<script>
export default {
    props: [
        'name',
        'id',
        'data'
    ],
    data() {
        return {
        };
    }
}
</script>